

















    import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import AlbumListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/PhotoGalleryModels/AlbumListResponse";
declare function initPortfolio() : void
@Component
    export default class PagePhotoGalleryComponent extends Vue{
        galleriesResponse: WsResponseModel<AlbumListResponse> = null;


        mounted() {
            this.$meta.setTitle('Фотогалерея');
            this.$api.PhotoGalleryService.GetAlbumsListEvent.once(this.onGetList.bind(this));
            this.$api.PhotoGalleryService.GetAlbumsList({});
        }
        onGetList(response: WsResponseModel<AlbumListResponse>) {
            this.galleriesResponse = response;
            setTimeout(()=>{
                initPortfolio();
            },200)
        }
    }
